"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlySubscriptionPlanService = void 0;
var MonthlySubscriptionPlan_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/MonthlySubscriptionPlan.json"));
var cryptoUnitConverter_1 = require("../../utils/cryptoUnitConverter");
var mainnetAddresses_1 = require("../mainnetAddresses");
var MAIN_NET_MONTHLY_SUBSCRIPTION_PLAN_CONTRACT_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.monthlySubscriptionPlanContract;
var MonthlySubscriptionPlanService = /** @class */ (function () {
    function MonthlySubscriptionPlanService(web3, monthlySubscriptionPlanContractAddress) {
        if (monthlySubscriptionPlanContractAddress === void 0) { monthlySubscriptionPlanContractAddress = MAIN_NET_MONTHLY_SUBSCRIPTION_PLAN_CONTRACT_ADDRESS; }
        this.web3 = web3;
        this.monthlySubscriptionPlanContractAddress = monthlySubscriptionPlanContractAddress;
        this.monthlySubscriptionContract = new this.web3.eth.Contract(MonthlySubscriptionPlan_json_1.default.abi, monthlySubscriptionPlanContractAddress);
    }
    Object.defineProperty(MonthlySubscriptionPlanService.prototype, "contractAddress", {
        get: function () {
            return this.monthlySubscriptionPlanContractAddress;
        },
        enumerable: false,
        configurable: true
    });
    MonthlySubscriptionPlanService.prototype.createANewVC = function (vcSubscriptionPayload) {
        var name = vcSubscriptionPayload.name, amountInFullOrbs = vcSubscriptionPayload.amountInFullOrbs, isCertified = vcSubscriptionPayload.isCertified, deploymentSubset = vcSubscriptionPayload.deploymentSubset;
        var amountInWeiOrbs = cryptoUnitConverter_1.weiOrbsFromFullOrbs(amountInFullOrbs);
        return this.monthlySubscriptionContract.methods
            .createVC(name, amountInWeiOrbs.toString(), isCertified, deploymentSubset)
            .send();
    };
    MonthlySubscriptionPlanService.prototype.extendSubscription = function (virtualChainSubscriptionExtensionPayload) {
        var amountInFullOrbs = virtualChainSubscriptionExtensionPayload.amountInFullOrbs, vcId = virtualChainSubscriptionExtensionPayload.vcId;
        var amountInWeiOrbs = cryptoUnitConverter_1.weiOrbsFromFullOrbs(amountInFullOrbs);
        console.log("Extending by amount", amountInWeiOrbs);
        return this.monthlySubscriptionContract.methods
            .extendSubscription(vcId, amountInWeiOrbs.toString())
            .send();
    };
    MonthlySubscriptionPlanService.prototype.setFromAccount = function (defaultAccountAddress) {
        this.monthlySubscriptionContract.options.from = defaultAccountAddress;
    };
    MonthlySubscriptionPlanService.prototype.readMonthlyRateInFullOrbs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rateAsString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.monthlySubscriptionContract.methods
                            .monthlyRate()
                            .call()];
                    case 1:
                        rateAsString = _a.sent();
                        return [2 /*return*/, cryptoUnitConverter_1.fullOrbsFromWeiOrbs(rateAsString)];
                }
            });
        });
    };
    MonthlySubscriptionPlanService.prototype.readTier = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.monthlySubscriptionContract.methods.tier().call()];
            });
        });
    };
    return MonthlySubscriptionPlanService;
}());
exports.MonthlySubscriptionPlanService = MonthlySubscriptionPlanService;
//# sourceMappingURL=MonthlySubscriptionPlanService.js.map